const ENCRYPTION_KEY = "monkeykart2025secretkey123456789"; // Exactly 32 chars


const hexToBytes = (hex) => {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
  }
  return bytes;
};

/**
 * Decrypt data using AES-256-GCM with Web Crypto API
 * @param {string} encryptedData - The encrypted data (hex format)
 * @returns {Promise<string>} - Decrypted JSON string
 */
export const decrypt = async (encryptedData) => {
  try {
    // Extract IV (first 32 hex chars = 16 bytes)
    const iv = hexToBytes(encryptedData.slice(0, 32));

    // Extract auth tag (next 32 hex chars = 16 bytes)
    const authTag = hexToBytes(encryptedData.slice(32, 64));

    // Extract encrypted text (remaining)
    const encryptedBytes = hexToBytes(encryptedData.slice(64));

    // Combine encrypted data with auth tag for GCM
    const ciphertext = new Uint8Array(encryptedBytes.length + authTag.length);
    ciphertext.set(encryptedBytes);
    ciphertext.set(authTag, encryptedBytes.length);

    // Import key
    const keyData = new TextEncoder().encode(ENCRYPTION_KEY);
    const key = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // Decrypt
    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        tagLength: 128, // 16 bytes = 128 bits
      },
      key,
      ciphertext
    );

    // Convert to string
    const decryptedString = new TextDecoder().decode(decryptedBuffer);
    return decryptedString;
  } catch (error) {
    console.error("Decryption error:", error);
    throw error;
  }
};

/**
 * Decrypt API response if encrypted
 * @param {object} response - The API response object
 * @returns {Promise<object>} - Decrypted data or original response
 */
export const decryptResponse = async (response) => {
  try {
    // Check if response is encrypted
    if (response.encrypted && response.data) {
      const decryptedString = await decrypt(response.data);
      return JSON.parse(decryptedString);
    }

    // Return original response if not encrypted
    return response;
  } catch (error) {
    console.error("Error decrypting response:", error);
    // Return original response on error
    return response;
  }
};
